import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { firstError, firstResponseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import {
  hideAddCollectionDatasets,
  removeCollectionDatasetAssignable,
  addCollectionDatasets,
  updateCollectionDatasetsAssignableProperties,
} from '../actions';
import CollectionDatasetAddRow from './CollectionDatasetAddRow';
import CollectionDatasetsAssignTable from '../components/CollectionDatasetsAssignTable';

const AssignCollectionDatasetsDialog = ({
  add,
  category,
  code,
  datasetsToAdd,
  hide,
  isDirty,
  name,
  readStatus,
  removeDataset,
  saveErrors,
  saveStatus,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  const setErrors = (newErrors) => updateProperties({ saveErrors: newErrors });

  return (
    <Dialog
      className="aridhia-assign-collection-datasets-dialog smallwizard"
      error={firstResponseError(saveErrors)}
      icon="object group outline"
      inProgress={saveStatus === states.PENDING}
      minimumDataEntryMet={isDirty}
      onClose={() => hide(category, code)}
      onDismiss={() => setErrors([])}
      onSave={add}
      saveMessageId="actions.apply"
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: 'collection.datasets.add.title' }, { name })}
    >
      <div className="aridhia-collection-datasets-sharing-dialog-container">
        <CollectionDatasetsAssignTable
          category={category}
          code={code}
          readStatus={readStatus}
          error={firstError(saveErrors)}
          onErrorDismiss={() => setErrors([])}
          datasets={datasetsToAdd}
          removeDataset={removeDataset}
        >
          <CollectionDatasetAddRow category={category} code={code} />
        </CollectionDatasetsAssignTable>
      </div>
    </Dialog>
  );
};

const dialogProps = ({
  category, code, saveStatus, saveErrors,
}, exists) => (
  {
    exists,
    category,
    code,
    saveStatus,
    saveErrors,
  }
);

const withoutItem = (datasetAssigningCollection) => (
  {
    ...dialogProps(datasetAssigningCollection, false),
    datasetsToAdd: [],
    isDirty: false,
    readStatus: states.NONE,
    readErrors: [],
  }
);

const withItem = (item, datasetAssigningCollection) => {
  const {
    readStatus, readErrors,
  } = datasetAssigningCollection;
  const isDirty = item.datasetsToAdd.results.length;

  return (
    {
      ...dialogProps(datasetAssigningCollection, true),
      datasetsToAdd: item.datasetsToAdd.results,
      name: item.name,
      isDirty,
      readStatus,
      readErrors,
    }
  );
};

const mapStateToProps = ({
  collectionDatasets: {
    datasetAssigningCollection,
    collectionDatasets,
  },
}) => {
  const item = findResult(collectionDatasets, datasetAssigningCollection.category, datasetAssigningCollection.code);
  return item ? withItem(item, datasetAssigningCollection) : withoutItem(datasetAssigningCollection);
};

const mapDispatchToProps = {
  add: addCollectionDatasets,
  hide: hideAddCollectionDatasets,
  removeDataset: removeCollectionDatasetAssignable,
  updateProperties: updateCollectionDatasetsAssignableProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignCollectionDatasetsDialog);
